import { Card, Row } from "antd";
import { styled } from "styled-components";

export const StyledCard = styled(Card)`
    border-radius: 10px;

    .ant-card-body {
        display: flex;
        justify-content: center;
        align-items: center;
    padding-top: 14px;
    padding-bottom: 6px;
    padding-right: 6px;
    padding-left: 6px;
  }
`;
